import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Card, Table, Modal, Radio, Tag, Spin, Empty, Typography } from "antd";
import { TransferManual } from "./trabsferManual";
import { ModelDetailWithdraw, ModelPaymentVoucher } from "../../components/Model/add-model";
import { getRowClassName } from "../../helpers/getRowClassName"; // , getRowClassName2
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import Apibank from "../../api/Apibank";
import {
  calculateAverageTime,
  confirmSwal,
  rejectedManualSwal,
  scrollToAntSpinContainer,
  sendApiTelegram_activity,
  showToast,
} from "../../utils";
import { SafetyCertificateOutlined } from "@ant-design/icons";
import { withTranslation } from "react-i18next";
import config from "../../config/app.config";
import { getRandomuserParams } from "../../utils";
import { ColumnsTab1, } from "../../components/Columns/columns-withdraw";
import { SearchMain } from "../../components/Search";
import moment from "moment";
import Apiauth from "../../api/Apiauth";
import AppContext from "../../components/AppContext";
import DataSourceMainSearch from "../Deposit/components/dataSource-main-Search";
import { getFuncCheckStatusTransection, getFuncReSend, } from "../../utils/funcCallback";
import UpdateDataByRoute from "../../helpers/isUpdateDataByRoute";
import { tagsBageStatus } from "../../helpers/tagsBage";
import Swal from "sweetalert2";
import { debounce } from "lodash";
import i18next, { t } from "i18next";
import { DetailModelCustomer } from "../../components/Model/index-model";
import { getSearchCustomerData } from "../../utils/fetchData";
import dayjs from "dayjs";
import { FooterWithdraw } from "../../components/Footer";

let now = new Date();
const { Title } = Typography;

const style = {
  display: "flex",
  flexDirection: "column",
  gap: 8,
};
class Index extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      show: false,
      isDataPayment: null,
      showModelAdd: false,
      showModelEdit: false,
      dropdownPlacement: "bottomRight",
      isSearching: false,
      showModelConfirm: false,
      isData: null,
      expanded: false,
      isLoad: false,
      spinner: false,
      showDetailCustomer: false,
      startDateSearch: null,
      endDateSearch: null,
      formData: {
        username: "",
        password: "",
      },
      dataTable: [],
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {
          startDate: moment(now).format("YYYY-MM-DD"),
          endDate: moment(now).format("YYYY-MM-DD"),
          searchText: "",
          type: "withdraw", //withdraw
          status: "SUCCESS",
        },
        sortField: null,
        sortOrder: null,
      },
      searchData: [],
      tableParamsSearch: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {},
        sortField: null,
        sortOrder: null,
      },
      setSwitchLoadding: null,
      setSwitchLoadding2: null,
      btnOk_QR: [],
      showTransactionSlipModel: false,
      openTransferManualModel: false,
      spinIcon: 0,
      statusChang: null,
      dataMember: null,
      manualData: null,
      customerData: null,
      showPaymentVoucherModel: false,
      isMobile: window.innerWidth <= 768,
    };
    this.fetchData = this.fetchData.bind(this);
    this.getSearchDataTransaction = this.getSearchDataTransaction.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.funRejected = this.funRejected.bind(this);
    this.toggleBtnOk_QR = this.toggleBtnOk_QR.bind(this);
    this.CheckStatusManual_Tranfer = this.CheckStatusManual_Tranfer.bind(this);
    this.Manual_QR = this.Manual_QR.bind(this);
    this.modelManual_QR = this.modelManual_QR.bind(this);
    this.getDetailTrans = this.getDetailTrans.bind(this);
    this.onUpdateAuto = this.onUpdateAuto.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onTab1Change = this.onTab1Change.bind(this);
    this.setActiveTabKey1 = this.setActiveTabKey1.bind(this);
    this.tableRef = React.createRef();
    this.debouncedFetch = debounce(this.fetchData, 100);
    this.debouncedSearch = debounce(this.getSearchDataTransaction, 500);
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleResize);
    window.scrollTo(0, 0);

    this.handleResize();
    this.setState({ isLoad: true }, () => this.debouncedFetch());

    if (this.context.setFetchWithdrawDataCallback) this.context.setFetchWithdrawDataCallback(this.handleReload);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
    this.debouncedFetch.cancel();
    this.debouncedSearch.cancel();
  }
  handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });

  handleReload = () => this.setState({ isLoad: true }, async () => await Promise.all([this.debouncedFetch()]));

  handleScroll = () => {
    const tableElement = this.tableRef.current;
    if (tableElement) {
      const isAtBottom = tableElement.getBoundingClientRect().bottom <= window.innerHeight;
      this.setState({ dropdownPlacement: isAtBottom ? "topLeft" : "bottomRight", });
    }
  };
  fetchData = async () => {
    const { tableParams } = this.state;
    const { handleCheckError, setCountTransPayOut, setAverageTime, setReloading } = this.context;

    const { startDate, endDate, type } = tableParams.filters;

    let searchData = {
      startDate,
      endDate,
      type,
    };
    const params = getRandomuserParams(tableParams);
    let itemParam = {
      limit: params.limit,
      offset: params.page,
      sort: params.orderby || "id",
      order: params.order || "desc",
      ...searchData,
    };

    try {
      const res = await Apibank.gtdata_withdraws(itemParam);

      if (res.data.success) {
        const fetchedData = Array.isArray(res.data.data.rows)
          ? res.data.data.rows
          : [];
        let averageTime = calculateAverageTime(fetchedData);

        this.setState(
          (prevState) => ({
            dataTable: fetchedData,
            isLoad: false,
            tableParams: {
              ...prevState.tableParams,
              pagination: {
                ...prevState.tableParams.pagination,
                total: res.data.data.count,
                current: tableParams.pagination.current || 1, // มั่นใจว่ามีค่าเริ่มต้น
                pageSize: tableParams.pagination.pageSize,
              },
            },
          }),
          () => {
            setCountTransPayOut(res.data.data.count);
            setAverageTime(averageTime, dayjs().format("YYYY-MM-DD HH:mm:ss"));
            setReloading(false)
          },
        );
      } else {
        showToast(
          "error",
          res.data.message || this.props.t("Failed to fetch data."),
        );
        this.setState({ isLoad: false, dataTable: [] });
      }
    } catch (error) {
      handleCheckError(error);
      console.error("Error fetching data:", error);
      this.setState({ dataTable: [], isLoad: false });
    }
  };

  handleTableChange = (pagination, filters, sorter, extra) => {
    const sortField = Array.isArray(sorter) ? sorter[0]?.field : sorter.field;
    const sortOrder = Array.isArray(sorter) ? sorter[0]?.order : sorter.order;
    this.setState(
      (prevState) => ({
        isLoad: true,
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: pagination.current,
            pageSize: pagination.pageSize,
          },
          filters: prevState.tableParams.filters,
          sortField: sortField,
          sortOrder: sortOrder,
        },
      }),
      async () => {
        scrollToAntSpinContainer();
        await Promise.all([this.debouncedFetch()]);
      },
    );
  };

  handleSearch = (value) => {
    const startDate =
      value?.startDate && moment(value.startDate?.$d).isValid()
        ? moment(value.startDate?.$d).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
    const endDate =
      value?.endDate && moment(value.endDate?.$d).isValid()
        ? moment(value.endDate?.$d).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");

    this.setState(
      (prevState) => ({
        isLoading: true,
        isSearching: true,
        startDateSearch: startDate,
        endDateSearch: endDate,
        tableParamsSearch: {
          ...prevState.tableParamsSearch,
          pagination: { ...prevState.tableParamsSearch.pagination, current: 1 },
          filters: { searchData: value, },
        },
      }),
      async () => await Promise.all([this.debouncedSearch()]),
    );
  };

  /**
   * @param {string} id - ID ของรายการธุรกรรม
   */
  resetLoadingAndFetchData = (id) => {

    setTimeout(() => {

      this.setState({ setSwitchLoadding: null, setSwitchLoadding2: null, isLoad: false, dataMember: null, manualData: null, spinner: false, },
        () => {
          this.toggleBtnOk_QR(id);
          this.closeModal();

        },
      );
    }, 1000)
  };
  destroyAll = () => Modal.destroyAll();

  // callback ฟังก์ชันสำหรับปุ่ม Reject (ถอนมือ) และกรณีหมดเวลาอัตโนมัติ (ยุบรวมกัน)
  funRejected = async (expire = false, item, status) => {

    // 1. ตรวจสอบสิทธิ์ก่อนแตก Object ป้องกันโค้ดพัง (Crash)
    if (item === "Not allowed") {
      return alert("!You are not authorized to view or take any action on any other store.");
    }

    const { id, merchantId, referenceId } = item || {};
    const { t } = this.props; // ดึง t ออกมาจาก props ให้ถูกต้อง
    const { resProfileAdmin } = this.context;
    const username = resProfileAdmin?.username || "Unknown";

    if (!id) return showToast("error", t("Invalid data."));

    let isStatusRefund = status === "REFUND";
    let noteResult = "";
    let msg = isStatusRefund ? t("Are you sure that this transaction failed to withdraw the money?") : t("Do you want to REJECT this item?");
    let footer = isStatusRefund ? t("Please notify the admin to process the refund for the customer.") : false;
    if (expire) {
      // กรณีหมดเวลาอัตโนมัติ
      noteResult = `${username} ${t("The transaction was not completed within the specified time.")}`;
    } else {
      // กรณีเจ้าหน้าที่กดปฏิเสธเอง ให้แสดงผลหน้าต่าง Swal ถามก่อน
      const resSwal = await rejectedManualSwal("question", msg, footer);
      if (!resSwal?.status) return this.resetLoadingAndFetchData(id); // ถ้ากดยกเลิกใน Swal ให้จบฟังก์ชัน

      noteResult = `${resSwal.note || ""} By ${username}`;
    }

    // 2. จัดการเปิดสถานะ Loading
    this.setState({ setSwitchLoadding: id, setSwitchLoadding2: id, isLoad: true });

    // 3. เตรียมโครงสร้างข้อมูลยิง API
    const details = `ยกเลิกรายการถอนเงิน Ref: ${referenceId} Note: ${noteResult}`;
    const nofData = { details, resProfileAdmin };
    const postData = {
      id,
      referenceId,
      note: noteResult,
      status: status,
      merchantId,
    };

    try {
      const response = await getFuncCheckStatusTransection(postData, nofData);
      if (response) {
        // ตรวจสอบสถานะการค้นหาเพื่อเลือกดึงข้อมูลให้ถูกต้อง
        if (this.state.isSearching && typeof this.getSearchDataTransaction === "function") await this.getSearchDataTransaction();

        if (typeof this.fetchData === "function") await this.fetchData();
      }
    } catch (error) {
      console.error("Error in getFuncCheckStatusTransection:", error);
    } finally {
      // ทำงานเสมอไม่ว่าจะยิงสำเร็จหรือพัง เพื่อปิดสถานะ Loading ไม่ให้หน้าจอค้าง
      setTimeout(() => {
        this.resetLoadingAndFetchData(id);
      }, 1000);
    }
  };

  toggleBtnOk_QR = (id) => {
    const { btnOk_QR = [] } = this.state;
    const position = btnOk_QR.indexOf(id);
    let newDetails = [...btnOk_QR];
    if (position !== -1) {
      newDetails.splice(position, 1);
      localStorage.removeItem(`toggleBtnOkQR-id-${id}`);
    } else {
      localStorage.setItem(`toggleBtnOkQR-id-${id}`, `true`);
      newDetails.push(id);
    }
    this.setState({ btnOk_QR: newDetails });
  };

  // แจ้งโอนเงินสำเร็จ (ถอนมือ) และเช็คสถานะการถอนเงิน
  CheckStatusManual_Tranfer = async (id) => {
    if (!id) return showToast("error", this.props.t("Invalid ID."));

    const { resProfileAdmin } = this.context;
    const adminName = resProfileAdmin?.username || "Unknown Admin";

    const details = `${adminName} (${resProfileAdmin?.admin_type}) อัพเดทสถานะถอนเงิน (ถอนมือ) ID: ${id} STATUS: success`;

    let isConfirmed = await confirmSwal("question", "Are you sure the money transfer was successful?",);

    if (isConfirmed) {
      this.setState({ setSwitchLoadding: id, isLoad: true, });

      Apibank.getChack_stuaus_kbank({ transaction_id: id })
        .then((res) => {
          sendApiTelegram_activity(res, "Manual", details, resProfileAdmin);
          if (res.data.success) {
            if (this.state.isSearching && typeof this.getSearchDataTransaction === "function") this.getSearchDataTransaction();
            if (typeof this.fetchData === "function") this.fetchData();
            showToast("success", res.data.message);
          } else {
            showToast("error", res.data.message);
          }
        })
        .catch((err) => {
          console.error("Error checking manual transfer status:", err);
          showToast("error", err?.message || "An error occurred while checking manual transfer status.",);
        })
        .finally(() => {
          this.resetLoadingAndFetchData(id);
          this.setState({ isLoad: false, });
          this.closeModal();
        });
    }
  };

  // ปุ่มถอนมือ
  Manual_QR = (item) => {
    if (!item || !item?.id) return showToast("error", this.props.t("Invalid data."));
    if (item === "Not allowed") return alert(`!You are not authorized to view or take any action on any other store.`,);

    this.setState({
      setSwitchLoadding: item.id,
      setSwitchLoadding2: item.id,
      isLoad: true,
      isLoading: true
    });

    Apibank.getUpdate_autokbank({ transaction_id: item?.id })
      .then((res) => {
        if (res.data.success) {
          this.setState(
            {
              dataMember: item,
              manualData: res?.data,
            },
            () => {
              this.toggleBtnOk_QR(item?.id);
              this.modelManual_QR();
            },
          );
          showToast("success", res.data.message || this.props.t("QR manual update successful."),);
          if (this.state.isSearching && typeof this.getSearchDataTransaction === "function") this.getSearchDataTransaction();
          if (typeof this.fetchData === "function") this.fetchData();
        } else {
          showToast("error", res.data.message);
          this.setState({ isLoad: false, isLoading: false });
        }
      })
      .catch((err) => {
        console.error("Error updating QR manually:", err);
        showToast("error", err.message || this.props.t("An error occurred during manual QR update."),);
        this.setState({ isLoad: false, isLoading: false });
      })
      .finally(() => {
        this.setState({
          setSwitchLoadding: 0,
          setSwitchLoadding2: 0,
        });
      });
  };

  handleCancel = () => {
    let { destroyAll } = this;
    if (destroyAll) destroyAll();
  };
  modalRef = null;
  closeModal = () => {
    if (this.modalRef) {
      this.modalRef.destroy();

      this.setState({ dataMember: null, manualData: null, isLoad: false, isLoading: false });
    }
  };
  // ฟังก์ชันสำหรับแสดง Modal ยืนยันการถอนมือ (Manual QR) และจัดการสถานะการถอนเงิน
  modelManual_QR = () => {
    const { t } = this.props;
    const { dataMember, manualData } = this.state;
    const currentLanguage = i18next.language;
    let tFormat = currentLanguage;
    let dFormat = tFormat === "lao" ? "lo" : tFormat;

    if (!dataMember || !manualData) return showToast("error", t("Cannot open modal: missing transaction data."));

    this.modalRef = Modal.confirm({
      title: (
        <Title level={5} className="m-0">{t("Confirm transaction")}</Title>

      ),
      icon: null,
      centered: false,
      width: 600,
      closable: false,
      cancelButtonProps: { danger: true },

      style: { top: 20 },
      content: (
        <div className="">
          <Spin spinning={false}>
            <TransferManual
              dataTranfer={manualData}
              dataMember={dataMember}
              config={config}
              t={t}
              dFormat={dFormat}
              rejectedManual={this.funRejected}
            />
          </Spin>
        </div>
      ),

      onOk: () => this.CheckStatusManual_Tranfer(manualData?.data?.id),
      okText: t("Confirm"),
      cancelText: t("rejected"),
      onCancel: () => this.funRejected(false, dataMember),
    });
  };

  getDetailTrans = (item) => {
    if (!item) return showToast("error", this.props.t("Invalid data."));
    this.setState({ showTransactionSlipModel: true, isData: item });
  };

  onUpdateAuto = async () => this.setState({ isLoad: false }, async () => await Promise.all([this.debouncedFetch()]));

  setActiveTabKey1 = (key) => this.setState({ activeTabKey1: key, isLoad: true }, () => this.fetchData());

  handleShow = (key) => {
    if (!key) return showToast("error", this.props.t("Invalid data."));
    if (key === "Not allowed") return alert(`!You are not authorized to view or take any action on any other store.`,);
    this.setState({ show: true, isData: key });
  };

  handleClose = () => {
    this.setState({
      show: false,
      showPaymentVoucherModel: false,
      showModelConfirm: false,
      showModelAdd: false,
      showModelEdit: false,
      showTransactionSlipModel: false,
      setSwitchLoadding: 0,
      statusChang: null,
      spinner: false,
      isData: null,
      isDataPayment: null,
      showDetailCustomer: false,
      customerData: null,
    });
  };
  handleIsSearching = (_e) => this.setState({ isSearching: _e });
  onTab1Change = (key) => {
    this.handleIsSearching(false);
    this.setActiveTabKey1(key);
  };
  getLoading = (_loading) => {
    this.setLoading(_loading);
    this.setLoadingCustomer(_loading);
  };

  handlCheckStatusTransection = (item) => {
    if (!item) return showToast("error", this.props.t("Invalid data."));
    this.setState({ setSwitchLoadding: item?.id, showModelConfirm: true }, () => this.modelConfirm(item),);
  };

  handleUpdateStatus = async (item) => {
    let { statusChang } = this.state;

    if (!item) return showToast("error", this.props.t("Invalid data."));
    if (!statusChang) return showToast("error", this.props.t("เลือก Status ที่ต้องการเปลี่ยน"));

    const { id, referenceId, merchantId } = item;

    let postData = {
      id: id,
      referenceId: referenceId,
      status: statusChang,
      merchantId: merchantId,
    };

    this.setState({ spinner: true });
    let res = await getFuncCheckStatusTransection(postData);
    if (!res) {
      this.setState({ spinner: false }, () => this.handleClose());
      return;
    } else if (res) {
      this.setState({ spinner: false }, async () => {
        await Promise.all([this.handleClose(), this.handleReload()]);
      });
      return;
    }
  };
  onChangStatus = (e) => this.setState({ statusChang: e.target.value });
  modelConfirm = (item) => {
    const { showModelConfirm, setSwitchLoadding, spinner } = this.state;
    const { t } = this.props;
    const { id } = item;
    if (!showModelConfirm) {
      console.log("showModelConfirm", `${showModelConfirm}`);
      return;
    }

    let disabled = setSwitchLoadding !== id;
    let itemOptions = [
      {
        label: (
          <Tag color={tagsBageStatus("SUCCESS")} children={t("SUCCESS")} />
        ),
        value: "SUCCESS",
      },
      {
        label: (
          <Tag color={tagsBageStatus("REJECTED")} children={t("REJECTED")} />
        ),
        value: "REJECTED",
      },
      {
        label: (
          <Tag
            color={tagsBageStatus("VERRIFY_FAILED")}
            children={t("VERRIFY_FAILED")}
          />
        ),
        value: "VERRIFY_FAILED",
      },
    ];
    Modal.confirm({
      title: <><SafetyCertificateOutlined /> {"Select status transaction"}</>,
      icon: null,
      content: (
        <>
          <label>
            <Radio.Group
              className="mt-2"
              style={style}
              defaultValue={item.status}
              onChange={this.onChangStatus}
              options={itemOptions}
            />
          </label>
        </>
      ),
      okButtonProps: {
        disabled: disabled,
        loading: spinner,
      },
      okText: spinner ? "loading..." : "Confirm",
      cancelText: "Cancel",
      onOk: () => this.handleUpdateStatus(item),
      onCancel: () => this.handleClose(),
      maskClosable: false,
    });
  };

  getSearchDataTransaction = async () => {
    const { merchantId, handleCheckError, } = this.context;
    this.setState({ isLoading: true });

    const { tableParamsSearch } = this.state;

    const { startDate, endDate, status, type, searchText, typeSearch } =
      tableParamsSearch?.filters?.searchData || {}; //, typeSearch
    const params = getRandomuserParams(tableParamsSearch);

    // กำหนดค่าเริ่มต้นของวันที่ค้นหา
    const searchStartDate =
      startDate && moment(startDate?.$d).isValid()
        ? moment(startDate?.$d).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
    const searchEndDate =
      endDate && moment(endDate?.$d).isValid()
        ? moment(endDate?.$d).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");

    let search = {
      status,
      type,
      search: searchText,
      typeSearch,
      startDate: searchStartDate,
      endDate: searchEndDate,
      merchantId: merchantId,
      limit: params.limit,
      page: params.page,
    };

    try {
      // ใช้ postData หรือ search ตามเงื่อนไขการค้นหา
      const res = await Apiauth.searchTransaction(search);

      if (res.data.success) {
        let isSearch = res?.data?.data_transactions || [];
        // let isSearchCount = res?.data?.transaction?.count || undefined;
        this.setState(
          (prevState) => ({
            searchData: isSearch,
            isLoading: false,
            tableParamsSearch: {
              ...prevState.tableParamsSearch,
              pagination: {
                ...prevState.tableParamsSearch.pagination,
                total: res?.data?.totalItems || 0,
              },
            },
          }),
          () => { scrollToAntSpinContainer(); },
        );
      } else {
        showToast(
          "error",
          this.props.t(res?.data?.message) ||
          this.props.t("Failed to fetch search data."),
        );
        this.setState({ searchData: [], isLoading: false });
      }
    } catch (error) {
      handleCheckError(error);
      console.error("Error fetching search data:", error);
      this.setState({ searchData: [], isLoading: false });
    }
  };
  handleReSend = async (item) => {
    if (item === "Not allowed") return alert(`!You are not authorized to view or take any action on any other store.`,);
    let id = item?.id;
    if (!id) {
      this.setState({ isLoad: false, isLoading: false, spinIcon: 0 });
      return showToast("error", "Id not found");
    }
    this.setState({ isLoad: true, isLoading: true, spinIcon: id });
    Swal.fire({
      title: "Do you want to Re Send?",
      text: "Press 'Confirm' to confirm the action, or 'Cancel'!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: t("Confirm"),
      cancelButtonText: t("Cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        let res = await getFuncReSend(id);
        if (res) {
          this.debouncedFetch();
          this.setState({ isLoad: false, isLoading: false, spinIcon: 0 });
        } else {
          this.setState({ isLoad: false, isLoading: false, spinIcon: 0 });
        }
      } else {
        this.setState({ isLoad: false, isLoading: false, spinIcon: 0 });
      }
    });
  };
  handlePaymentVoucher = async (item) => {
    if (!item?.settleSlip) return alert("error: no data settleSlip.");
    this.setState({ isDataPayment: item, showPaymentVoucherModel: true });
  };

  onShowDetailCustumer = (e) => this.setState({ statusChang: e.target.value });

  handleShowModelDetelCustomer = async (item) => {
    if (!item || !item?.bank) return alert(this.props.t("Invalid data."));
    let info = JSON.parse(item?.bank);
    this.setState({ customerData: info }, () => this.detailsCustomer(item));
  }

  onSearchCustomerData = async (event) => {
    let res = await getSearchCustomerData(event);
    if (!res) return showToast("error", this.props.t("Customer data not found."));
    this.setState({ showDetailCustomer: true, isData: res });
  };

  detailsCustomer = async (item) => {
    if (!item) return alert(this.props.t("Invalid data."));
    let { merchantId } = item || {};
    let { customerData } = this.state;

    const newTableParams = {
      search: customerData?.accountNo,
      typeSearch: "account_no",
      merchantId: merchantId,
    };
    await this.onSearchCustomerData(newTableParams);

  }
  render() {
    const { t, i18n } = this.props;
    const currentLanguage = i18n.language;
    const { handleReSend, handlCheckStatusTransection, CheckStatusManual_Tranfer, handlePaymentVoucher, handleShowModelDetelCustomer } = this;
    const { resAllDataMerchang, nameMerchang, accPayoutActiveBank, activeKey1, allBankAccountData, resProfileAdmin } = this.context;
    const {
      activeTabKey1,
      show,
      isData,
      isLoad,
      tableParams,
      dataTable,
      setSwitchLoadding,
      setSwitchLoadding2,
      isSearching,
      searchData,
      tableParamsSearch,
      isLoading,
      spinIcon,
      startDateSearch,
      endDateSearch,
      spinner,
      showPaymentVoucherModel,
      isDataPayment,
      showDetailCustomer,
      expanded
    } = this.state;

    const displayStartDate = isSearching ? startDateSearch : moment(tableParams.filters.startDate).format("YYYY-MM-DD");
    const displayEndDate = isSearching ? endDateSearch : moment(tableParams.filters.endDate).format("YYYY-MM-DD");

    const titleText = isSearching ? t("transaction_list_search", { date: `${displayStartDate} - ${displayEndDate}` }) : t("transaction_list_all");
    const totalItems = isSearching ? tableParamsSearch?.pagination?.total : tableParams?.pagination?.total;

    const tabList = [
      {
        key: "tab1",
        tab: <>{titleText}{" : "}{totalItems} {this.props.t("items")} </>,
      },
    ];
    const columnProps = {
      handleShow: this.handleShow,
      showToast: showToast,
      Manual_QR: this.Manual_QR,
      funRejected: this.funRejected,
      setSwitchLoadding: setSwitchLoadding,
      setSwitchLoadding2: setSwitchLoadding2,
      dropdownPlacement: this.state.dropdownPlacement,
      activeBank: accPayoutActiveBank,
      handleReSend,
      spinIcon,
      handlCheckStatusTransection,
      CheckStatusManual_Tranfer,
      currentLanguage,
      handlePaymentVoucher,
      detailsCustomer: handleShowModelDetelCustomer,
      resProfileAdmin,
      expanded
    };

    const handleTableSearchChange = (pagination, filters, sorter) => {
      const sortField = Array.isArray(sorter) ? sorter[0]?.field : sorter.field;
      const sortOrder = Array.isArray(sorter) ? sorter[0]?.order : sorter.order;

      this.setState(
        (prevState) => ({
          isSearching: true,
          isLoading: true,
          tableParamsSearch: {
            ...prevState.tableParamsSearch,
            pagination,
            filters: {
              ...prevState.tableParamsSearch.filters,
              searchData: prevState.tableParamsSearch.filters.searchData,
            },
            sortField: sortField,
            sortOrder: sortOrder,
          },
        }),
        async () => await Promise.all([this.debouncedSearch()]),
      );
    };
    const columns = ColumnsTab1(t, columnProps);
    const contentList = {
      tab1: (<div className="body table-responsive">
        <Table
          className="col-lg-12"
          columns={columns}
          rowKey={(record) => record.id}
          onChange={this.handleTableChange}
          dataSource={dataTable}
          loading={isLoad || spinner}
          locale={{ emptyText: (<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("No data")} />), }}
          pagination={{
            ...tableParams.pagination,
            showSizeChanger: true,
            showTotal: (total, range) => {
              // คำนวณหน้าปัจจุบัน
              const currentPage = tableParams.pagination.current;
              // คำนวณจำนวนหน้าทั้งหมด
              const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

              return (
                <span>
                  <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                  <span style={{ marginLeft: 10 }}>
                    {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                  </span>
                </span>
              );
            },
          }}
          rowClassName={getRowClassName}
          scroll={{ x: "max-content" }}
        />
      </div>),
    };

    return (
      <>
        <ModelDetailWithdraw
          handleClose={this.handleClose}
          isData={isData}
          show={show}
          title={t("Withdrawal")}
          resAllDataMerchang={resAllDataMerchang}
          nameMerchang={nameMerchang}
          t={t}
        />
        <DetailModelCustomer
          handleClose={this.handleClose}
          isData={isData}
          showToast={showToast}
          show={showDetailCustomer}
          activeTabKey1={activeTabKey1}
          allBankAccountData={allBankAccountData}
          resAllDataMerchang={resAllDataMerchang}
          nameMerchang={nameMerchang}
          t={t}
        />
        <ModelPaymentVoucher
          handleClose={this.handleClose}
          isData={isDataPayment}
          show={showPaymentVoucherModel}
          title={"Withdrawal"}
          resAllDataMerchang={resAllDataMerchang}
          nameMerchang={nameMerchang}
          t={t}
        />

        <UpdateDataByRoute onUpdateAuto={this.onUpdateAuto} />
        <div style={{ flex: 1 }}>
          <div>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("withdraw-transaction")}
                Breadcrumb={[
                  {
                    name: removeSlashesFromPath(window.location.pathname),
                    navigate: window.location.pathname,
                  },
                ]}
              />
              {/* Search */}
              <SearchMain t={t} type={"withdraw"} onSearch={this.handleSearch} handleIsSearching={this.handleIsSearching} activeKey1={activeKey1} />

              <Card
                tabList={tabList}
                activeTabKey={activeTabKey1}
                onTabChange={this.onTab1Change}
              >

                {!isSearching ? (
                  contentList[activeTabKey1]
                ) : (
                  <DataSourceMainSearch
                    columns={columns}
                    dataSource={searchData}
                    isSearching={isSearching}
                    getRowClassName={getRowClassName}
                    onChange={handleTableSearchChange}
                    tableParams={tableParamsSearch}
                    handleIsSearching={this.handleIsSearching}
                    loading={isLoading}
                    t={t}
                  />
                )}

                {/* Footer */}
                <FooterWithdraw t={t} />
              </Card>
            </div>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});

export default connect(mapStateToProps, {})(withTranslation()(Index));
